import React, {useState, Fragment} from 'react';   
import Warning from '../../../assets/images/warning.png'
import classes from './InputRetAgeWarning.module.css'
import InfoModal from '../../general/InfoModal'

const InputRetAgeWarning = (props) => {
    
    const [show_modal, set_show_modal] = useState(false)

    const valid_ret_age = String(props.ret_age).length > 1
    if(props.spa_age && valid_ret_age) {
        const status = props.status
        const spa_years = props.spa_age['years']
        const spa_months = props.spa_age['months']
        const spa_age = spa_years + spa_months / 12
        const npa_mapper = {
            '1995 Section' : status === 'Neither of these' ? 60 : 55,
            '2008 Section' : 65, 
            '2015' : Math.max(spa_age, 65)
        }
        const legacy_scheme = props.scheme
        const legacy_npa = npa_mapper[legacy_scheme]
        const reformed_npa = npa_mapper['2015']
        const ret_age = props.ret_age
        

        var message 

        if(legacy_npa > ret_age) {
            message = 'WARNING: This retirement age is earlier than your retirement age for the ' + legacy_scheme + ' and the the 2015 Scheme. Click this box to understand how early retirement can reduce your pension benefits.'
        } else if(reformed_npa > ret_age) {
            message = 'WARNING: This retirement age is earlier than your retirement age for the 2015 Scheme. Click this box to understand how early retirement can reduce your pension benefits.'
        } else {
            message = ''
        }

        var modal_message = <Fragment> 
            <h1> Implications of early retirement </h1>
            <p> 
            Each part of the Scheme has a different normal pension age, or NPA. 
            This is the earliest age you can claim your benefits without any reductions. 
            </p>
            <p> Your NPA for your {legacy_scheme} benefits is age {legacy_npa} </p> 
            <p> In the 2015 Scheme, 
            it’s the same as your state pension age, which is {spa_years} years 
            and {spa_months} months. </p>
            <p>
             Any benefits you take before your NPA will be reduced because you will receive them for longer.
            You don’t have to take all your benefits at the same time. 
            On your detailed results page, you can see how your retirement age might affect the value of your benefits. 
        </p>
        </Fragment>
    } else {
        var message = ''
        var modal_message = null
    }
    



    return(
        <div className = {classes.main_container + ' ' + (props.invisible || props.ret_age === undefined || message === '' ? classes.invisible : '')} > 
            <div className = {classes.sub_container} onClick = {() => { set_show_modal(true)}}> 
                <div className = {classes.img_container}> 
                    <img src = {Warning} alt = 'Warning symbol'/>
                </div>
                <p> {message}  </p>
            </div>
            {show_modal && <InfoModal
            infoMessage = {modal_message}
            modalHandler = {() => { set_show_modal(false)}}
            />}
        </div>
    )
}

export default InputRetAgeWarning